export enum ChatStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
}

export interface MessageItem {
    id: number
    content: string
    role: string
    name?: string
    phoneNumber?: string
    createdAt: string
    updatedAt: string
    metadata?: any
    /** Quem da equipe escreveu (pessoa ou usuário de IA). Nulo no contato e nas automáticas. */
    authorUserId?: number | null
    department?: {
        id: number
        name: string
    }
    attendant?: {
        id: number
        name: string
    }
}

export type ChatChannel = 'WHATSAPP' | 'INSTAGRAM' | 'MESSENGER' | 'DEX_TALK'

/** Mensagem que fez a conversa aparecer na busca (só vem quando há termo de busca). */
export interface ChatMessageMatch {
    chatId: number
    messageId: number
    /** `user` = contato, `company` = equipe, `assistant` = IA. */
    role: 'user' | 'company' | 'assistant'
    /** Recorte da mensagem em volta do termo. */
    snippet: string
    createdAt: string
}

export interface Chat {
    id: number
    /** Preenchido na busca quando o termo aparece no texto da conversa. */
    messageMatch?: ChatMessageMatch | null
    summary?: string | null
    summaryFull?: string | null
    context?: string | null
    /** Vazio no Instagram/Messenger até o contato informar um telefone. */
    phoneNumber: string
    contactId: string
    /** Canal da conversa; ausente = WhatsApp (conversas anteriores ao campo). */
    channel?: ChatChannel
    /** IGSID (Instagram) ou PSID (Messenger). */
    externalContactId?: string | null
    /** Mensagens do contato ainda não vistas (contador compartilhado pela equipe). */
    unreadCount?: number
    /** Última mensagem de qualquer lado: ordena a lista. */
    lastMessageAt?: string | null
    name: string
    metadata?: any
    status: ChatStatus
    files?: any
    createdAt: string
    updatedAt: string
    // Nulo quando o setor não tem agente de IA: o atendimento é só humano.
    attendantId: number | null
    departmentId: number
    companyId: number
    partnerId?: number | null
    deleted: boolean
    priority: number
    aiOnHold: boolean
    waitingForHuman?: boolean
    department?: {
        id: number
        name: string
    }
    attendant?: {
        id: number
        name: string
    }
    clientId?: number | null
    leadId?: number | null
    lead?: {
        id: number
        name: string
        phoneNumber: string
        status: string
        source: string
    } | null
    messages?: MessageItem[]
}
